module.exports = __webpack_public_path__ + "img/avatar3.681e7e52.png";